import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'

export class ReviewCompleted extends Component {

    goToHomePage = () => {
        this.props.history.push('/');
    }

    render() {
        return (
            <div className="request-container">
                <div className="request-completed" >

                    <h5>Request Approved</h5>
                    <span className="request-container-header">
                        This request has been approved successfully. We will notify {this.props.requestingUser} via email when the data is ready for download.
                    </span>

                    <button
                        onClick={this.goToHomePage}>
                        Go to HomePage ...
                    </button>

                </div>
            </div>
        )
    }
}

export default withRouter(ReviewCompleted)
